import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Colors from '../common/NekoTheme';
import Theme from '../common/NekoTheme';

const Tag = Styled.div`
  background-color: ${Colors.yellow};
  position: relative;
  border-radius: 10px;
  color: ${Colors.white};
  font-family: ${Theme.fontFamily};
  font-size: 9px;
  line-height: 11px;
  padding: 5px 8px;
  text-transform: uppercase;

  &.inline {
    display: inline;
    margin-left: 5px;
    vertical-align: middle;
  }
`;

/**
 * @param {string} className
 * @param {string|object} icon
 * @param {bool} disabled
 * @param {function} onClick
 */
const StyledProOnly = (props) => {

  const { show = true, className, ...rest } = props;

  return (
    show ? <Tag className={`${className || ''}`} {...rest} >Pro Only</Tag> : null
  );
};

const ProOnly = (props) => {
  return (<StyledProOnly {...props} />);
}

ProOnly.propTypes = {
  show: PropTypes.bool,
  className: PropTypes.string
};

ProOnly.defaultProps = {
  show: true,
  className: undefined
};

export { ProOnly };
